export default function(instance) {
  return {
    getAllRequests(data) {
      //remove empty value
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      if (!(Object.keys(data).length === 0 && data.constructor === Object)) {
        return instance.get("/api/applications/admin/all/", {
          params: data
        });
      } else {
        return instance.get("/api/applications/admin/all/");
      }
    }
  };
}
